
export default {
  props: {
    product: Object,
    newest: Boolean,
  },
  data() {
    return {
      popoverId: `label-text-${this.product?.id || 0}-${this.product?.variant?.id || 0}`,
      isMounted: false,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isMounted = true
    })
  },
}
